import Hero from "./components/Hero";
import HotBoard from "./components/HotBoard";
import SpreadTimeline from "./components/SpreadTimeline";
import StageBreakdown from "./components/StageBreakdown";
import FlashFeed from "./components/FlashFeed";
import EditorNote from "./components/EditorNote";
import Footer from "./components/Footer";

export default function Home() {
  return (
    <div className="min-h-screen bg-white font-sans text-stone-900 antialiased">
      <Hero />
      <main>
        <HotBoard />
        <SpreadTimeline />
        <StageBreakdown />
        <FlashFeed />
        <EditorNote />
      </main>
      <Footer />
    </div>
  );
}